export const TeamShiftAssignmentActionTypes = {
  API_RESPONSE_SUCCESS: '@@teamShiftAssignment/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@teamShiftAssignment/API_RESPONSE_ERROR',
  EXPORT_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/EXPORT_TEAM_SHIFT_ASSIGNMENT',
  IMPORT_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/IMPORT_TEAM_SHIFT_ASSIGNMENT',
  GET_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/GET_TEAM_SHIFT_ASSIGNMENT',
  GET_TEAM_SHIFT_ASSIGNMENT_BY_ID: '@@teamShiftAssignment/GET_TEAM_SHIFT_ASSIGNMENT_BY_ID',
  ADD_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/ADD_TEAM_SHIFT_ASSIGNMENT',
  UPDATE_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/UPDATE_TEAM_SHIFT_ASSIGNMENT',
  DELETE_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/DELETE_TEAM_SHIFT_ASSIGNMENT',
  RESET_TEAM_SHIFT_ASSIGNMENT: '@@teamShiftAssignment/RESET_TEAM_SHIFT_ASSIGNMENT',
};